import script from "./CustomSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomSelect.vue?vue&type=script&lang=ts&setup=true"

import "./CustomSelect.vue?vue&type=style&index=0&id=3d78ebf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d78ebf0"]])

export default __exports__